import Component from './rules-detail.component';

export default Component;
